<template>
    <div>
        <!-- 物流基本信息 -->
        <div class="logistics-info">
            <div class="info-item">
                <span class="info-label">订单编号：</span>
                <span class="info-value">{{ logisticsData.OrderCode }}</span>
                <span class="copy-btn" @click="copyText(logisticsData.OrderCode)">复制</span>
            </div>
            <div class="info-item">
                <span class="info-label">快递公司：</span>
                <span class="info-value">{{ logisticsData.ShipperCode }}</span>
            </div>
            <div class="info-item">
                <span class="info-label">物流单号：</span>
                <span class="info-value">{{ logisticsData.express_no }}</span>
                <span class="copy-btn" @click="copyText(logisticsData.express_no)">复制</span>
            </div>
        </div>
        <div class="logistics-container">
            <!-- 物流轨迹时间轴 -->
            <div class="logistics-timeline">
                <div v-for="(step, index) in logisticsData.data" :key="index" class="timeline-item"
                    :class="{ 'active': index === 0 }">
                    <!-- 时间轴节点 -->
                    <div class="timeline-node">
                        <div class="node-circle"></div>
                        <div class="node-line" v-if="index < logisticsData.data.length - 1"></div>
                    </div>
                    <!-- 物流信息内容 -->
                    <div class="timeline-content">
                        <div class="content-desc">{{ step.context }}</div>
                        <div class="content-time">{{ step.time }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ViewLogistics',
    props: {
        orderId: {
            type: [String, Number],
            default: ''
        },
        isAfter: {
            type: Boolean,
            default: false
        },
        // 售后订单物流详情
        isShouhou: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            logisticsData: {
                data: []
            }
        };
    },
    mounted() {
        this.getLogisticsInfo();
    },
    methods: {
        // 获取物流信息的方法（可根据实际需求实现）
        getLogisticsInfo() {
            if (this.isShouhou) {
                this.$api.getReturnLogistics({
                    id: this.orderId,
                }).then(res => {
                    this.logisticsData = res;
                }).catch(err => {
                    console.error('获取物流信息失败', err);
                });
            } else {
                if (this.isAfter) {
                    this.$api.getAfterLogisticsInfo({
                        id: this.orderId,
                    }).then(res => {
                        this.logisticsData = res;
                    }).catch(err => {
                        console.error('获取物流信息失败', err);
                    });
                } else {
                    this.$api.getLogisticsInfo({
                        order_id: this.orderId,
                    }).then(res => {
                        this.logisticsData = res;
                    }).catch(err => {
                        console.error('获取物流信息失败', err);
                    });
                }
            }
        },




        // 复制文本到剪贴板
        copyText(txt) {
            navigator.clipboard.writeText(txt)
                .then(() => {
                    this.$message.success('复制成功');
                })
                .catch(err => {
                    console.error('复制失败:', err);
                    this.$message.warning('复制失败');
                });
        }
    }
}
</script>

<style scoped>
.logistics-container {
    padding: 15px;
    background-color: #f5f7fa;
    border-radius: 8px;
}

/* 物流基本信息样式 */
.logistics-info {
    margin-bottom: 20px;
}

.info-item {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
}

.info-item:last-child {
    margin-bottom: 0;
}

.info-label {
    width: 80px;
    font-size: 14px;
    color: #666;
}

.info-value {
    font-size: 14px;
    color: #333;
}

.copy-btn {
    padding: 4px 8px;
    font-size: 12px;
    color: #409EFF;
    background-color: #ecf5ff;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s;
    margin-left: 24px;
}

.copy-btn:hover {
    background-color: #d9ecff;
}

/* 物流轨迹时间轴样式 */
.logistics-timeline {
    position: relative;
    padding-left: 40px;
}

.timeline-item {
    display: flex;
    margin-bottom: 25px;
    position: relative;
}

.timeline-item:last-child {
    margin-bottom: 0;
}

/* 时间轴节点样式 */
.timeline-node {
    position: relative;
}

.node-circle {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: #ccc;
    position: absolute;
    left: -36px;
    top: 4px;
    transition: all 0.3s;
}

.node-line {
    position: absolute;
    left: -30px;
    top: 18px;
    width: 2px;
    height: calc(100% + 25px);
    background-color: #e0e0e0;
}

/* 物流信息内容样式 */
.timeline-content {
    flex: 1;
}

.content-desc {
    font-size: 14px;
    color: #666;
    margin-bottom: 5px;
    line-height: 1.5;
}

.content-time {
    font-size: 12px;
    color: #999;
}

/* 激活状态样式 */
.timeline-item.active .node-circle {
    background-color: #409EFF;
    width: 16px;
    height: 16px;
    left: -38px;
    top: 2px;
}

.timeline-item.active .content-desc {
    color: #409EFF;
    font-weight: 500;
}
</style>